export default __webpack_public_path__ + "static/media/three-wines.9cef6e16.webp";